<template>
    <div>
        <!-- 左按钮 -->
        <button class="switch-btn left-btn" @click="prev" :disabled="mainProjectIndex === 0" v-if="mainProjects.length>1">
            ←
        </button>
        <!-- 右按钮 -->
        <button class="switch-btn right-btn" @click="next" :disabled="mainProjectIndex === mainProjects.length - 1" v-if="mainProjects.length>1">
            →
        </button>

        <!-- 四川中烟工业有限责任公司什邡卷烟厂项目 -->
        <div class="content" v-if="mainProjectIndex==0">
            <div class="title">
                <div class="icon"> </div>
                <h1>四川中烟工业有限责任公司什邡卷烟厂项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left" style="margin-top: 4em;width:18em;">
                    四川中烟工业有限责任公司什邡卷烟厂位于四川省德阳市，总建设用地面积155,429.53平方米（约233.14亩），是一家国有烟草生产企业。作为烟草行业首家通过“智能制造能力成熟度四级”认证的卷烟工厂，该厂2024年单箱卷烟综合能耗显著降低至14.8公斤标煤，并荣获国家级5G工厂称号。</p>
                <img src="../../../../../assets/img/case/yancao/yancao_shifang.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/yancao/yancao_shifang.png" class="company-img"></img></p>
            <p>
               四川中烟工业有限责任公司什邡卷烟厂位于四川省德阳市，总建设用地面积155,429.53平方米（约233.14亩），是一家国有烟草生产企业。作为烟草行业首家通过“智能制造能力成熟度四级”认证的卷烟工厂，该厂2024年单箱卷烟综合能耗显著降低至14.8公斤标煤，并荣获国家级5G工厂称号。</p>
               <p>本项目通过构建多层次、集成化的能源管控体系，有效支持工厂实现绿色低碳与智能化运营目标。项目成果显著，实现年节约能源费用超过1200万元，锅炉、空压机等关键设备能耗降低10%-20%，单位产品碳排放下降8%。并在当年企业“智能制造能力成熟度四级”认证中能源管理模块取得满分评价。本案例验证了能源管理系统在流程制造领域的广泛适用性，为行业提供了可复制、可推广的技术改造范本。</p>
                <p style="text-align: center;"><img src="../../../../../assets/img/case/yancao/yancao_shifang_1.png" style="width: 60%;margin:2em auto;"></img></p>
        </div>
        
        <foot-img-carousel type="yancao" :projects="otherProjects" @change="showProjectDetail"></foot-img-carousel>
    </div>
</template>

<script>
import footImgCarousel from './footImgCarousel.vue';
export default{
    components:{
        footImgCarousel
    },
    data(){
        return {
            mainProjectIndex:0,
            mainProjects: [
                {
                    cover: "shifang",
                    title: "什邡卷烟厂项目",
                    hasDetail: true
                }
            ],
            otherProjects:[
                {
                    cover: "shifang2",
                    title: "四川中烟工业有限责任公司烟叶原料仓库建设项目",
                },
                {
                    cover: "yanan",
                    title: "延安卷烟厂项目",
                },
                {
                    cover: "shanxizhongyan",
                    title: "陕西中烟经营业务用房制冷及热水系统节能提升改造项目",
                },
                {
                    cover: "chengcheng",
                    title: "陕西中烟工业澄城卷烟厂",
                },
                {
                    cover: "haomao",
                    title: "陕西好猫卷烟材料厂配套基地建设项目弱电工程设备采购及安装项目",
                }
            ]
        }
    },
  methods: {
        showProjectDetail(index) {
            this.mainProjectIndex =index
        },
        prev() {
            if (this.mainProjectIndex > 0) this.mainProjectIndex--;
        },
        next() {
            if (this.mainProjectIndex < this.mainProjects.length - 1) this.mainProjectIndex++;
        }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>